import React, { useMemo, useState } from 'react'
import Accordion from '../../atoms/Accordion/Accordion'
import { Breadcrumbs, MetaSeo } from '../..'

const FAQPanel = ({ categorieFaq, page }) => {

  const [currentActive, setCurrentActive] = useState(0)

  const filteredCategorieFaq = useMemo(
    () => categorieFaq.filter(({ faq }) => Array.isArray(faq) && faq.length > 0),
    [categorieFaq]
  )

  const { categorie, domande, titolo } = useMemo(() => {
    return filteredCategorieFaq.reduce((acc, { nome, faq }, index) => {

      const isSelected = index === currentActive

      acc["categorie"].push(
        <div
          className={`faq_container_sidepanel__titolo${isSelected ? ' faq_container_sidepanel__titolo--active' : ''
            }`}
          onClick={() => {
            setCurrentActive(index)
          }}
          key={nome}
        >
          {nome}
        </div>)

      if (isSelected) {
        acc["domande"] = faq.map(({ domanda, risposta }) => {
          return (
            <div className="faq_container_item" key={domanda}>
              <Accordion placeholder={domanda} withoutBorder>
                <div className="faq_container_item__risposta">{risposta}</div>
              </Accordion>
            </div>
          )
        })
        acc.titolo = nome

      }
      return acc

    }, {
      domande: [],
      titolo: currentActive > -1 ? filteredCategorieFaq?.[currentActive]?.nome : "",
      categorie: []
    })


  }, [filteredCategorieFaq, currentActive])


  return (
    <div className="page">
      <div className="w-container">
        <Breadcrumbs breadcrumbs={page.breadcrumbs} />
        <MetaSeo seo={page.seo} />
        <h1 className="page__title">{page.titolo}</h1>
        <div className="faq_container">
          <div className="faq_container_sidepanel">{categorie}</div>
          <div className="faq_container_items">
            <p className="faq_container_items__titolo">{titolo}</p>
            {domande}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FAQPanel
